export enum OutsourceSummaryEnum {
  DEPARTMENT = 'DEPARTMENT',
  VENDOR = 'VENDOR'
}
